var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d2-layout-header-aside-group",
      class: { grayMode: _vm.grayActive },
      style: _vm.styleLayoutMainGroup
    },
    [
      _c("div", { staticClass: "d2-layout-header-aside-mask" }),
      _c(
        "div",
        {
          staticClass: "d2-layout-header-aside-content",
          attrs: { flex: "dir:left" }
        },
        [
          _c("div", { attrs: { "flex-box": "0" } }, [_c("mainMenu")], 1),
          _c(
            "div",
            {
              staticClass: "d2-theme-container",
              attrs: { "flex-box": "1", flex: "dir:top" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "d2-theme-header",
                  style: { opacity: this.searchActive ? 0.5 : 1 },
                  attrs: { "flex-box": "0", flex: "" }
                },
                [
                  _c("div", { staticClass: "unfold-btn-wrap" }, [
                    _c("i", {
                      staticClass: "el-icon-s-fold",
                      on: { click: _vm.handleUnfoldBtn }
                    })
                  ]),
                  _c(
                    "el-breadcrumb",
                    { staticClass: "breadcrumb-wrap" },
                    _vm._l(_vm.breadcrumb, function(item) {
                      return _c("el-breadcrumb-item", { key: item }, [
                        _vm._v(_vm._s(item))
                      ])
                    }),
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "d2-header-right",
                      attrs: { "flex-box": "1", flex: "main:right" }
                    },
                    [
                      _vm.userInfo.USER_NAME === "ADMIN"
                        ? _c("header-envConfig")
                        : _vm._e(),
                      _c("header-downloadList"),
                      _c("d2-header-search", {
                        on: { click: _vm.handleSearchClick }
                      }),
                      _c("d2-header-fullscreen"),
                      _c("d2-header-tools", {
                        staticStyle: { display: "flex" }
                      }),
                      _c("d2-header-locales"),
                      _c("orgSelect"),
                      _c("d2-header-user"),
                      _c(
                        "div",
                        { staticClass: "powerOff" },
                        [
                          _c("d2-icon", {
                            staticClass: "d2-mr-5",
                            attrs: { name: "power-off" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.logOff.apply(null, arguments)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "d2-theme-container-main",
                  attrs: { "flex-box": "1", flex: "" }
                },
                [
                  _c("transition", { attrs: { name: "fade-scale" } }, [
                    _vm.searchActive
                      ? _c(
                          "div",
                          {
                            staticClass: "d2-theme-container-main-layer",
                            attrs: { flex: "" }
                          },
                          [
                            _c("d2-panel-search", {
                              ref: "panelSearch",
                              on: { close: _vm.searchPanelClose }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]),
                  _c("transition", { attrs: { name: "fade-scale" } }, [
                    !_vm.searchActive
                      ? _c(
                          "div",
                          {
                            staticClass: "d2-theme-container-main-layer",
                            attrs: { flex: "dir:top" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d2-theme-container-main-header",
                                attrs: { "flex-box": "0" }
                              },
                              [_c("d2-tabs")],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "d2-theme-container-main-body",
                                attrs: { "flex-box": "1" }
                              },
                              [
                                _c(
                                  "transition",
                                  {
                                    attrs: {
                                      name: _vm.transitionActive
                                        ? "fade-transverse"
                                        : ""
                                    }
                                  },
                                  [
                                    _c(
                                      "keep-alive",
                                      [
                                        _c("router-view", {
                                          key: _vm.routerViewKey
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }